<div class="program-header">
  <div class="program-header__row">
    @if (!hideTitle) {
      <h1 class="program-header__title headline5">{{ displayTitle }}</h1>
    }

    <div class="program-header__actions">
      @if (showActions) {
        <ptl-content-language-menu
          [languages]="availableLanguages"
          [selectedCode]="selectedLanguageCode"
          (languageSelected)="languageSelect($event)"
        ></ptl-content-language-menu>
      }

      @if (canEdit) {
        <ptl-button
          class="edit-btn"
          [size]="'s'"
          type="smoke"
          [icon]="LucidePencil"
          [text]="'translations.programs.edit.editContent' | transloco"
          (clicked)="editClicked.emit()"
        ></ptl-button>
      }

      @if (showActions) {
        <ptl-button
          type="smoke"
          [size]="'s'"
          [icon]="LucideShare2"
          [ariaLabel]="'translations.global.ariaLabels.icons.share' | transloco"
          (clicked)="shareProgram()"
        ></ptl-button>

        @if (!isCard) {
          <ptl-button
            type="smoke"
            [size]="'s'"
            [icon]="$any(program)?.favorite ? LucideBookmarkCheck : LucideBookmark"
            [ariaLabel]="'translations.global.ariaLabels.icons.save' | transloco"
            (clicked)="saveItem()"
          ></ptl-button>
        }

        <ptl-button
          type="smoke"
          [size]="'s'"
          [icon]="LucideDownload"
          [ariaLabel]="'translations.global.ariaLabels.icons.download' | transloco"
          (clicked)="downloadReport()"
        >
          @if (downloadInProgress) {
            <mat-spinner [diameter]="16"></mat-spinner>
          }
        </ptl-button>
      }
    </div>
  </div>

  @if (report) {
    <div class="card-view__report-container">
      <ptl-playlist-report
        #playlistReportComponent
        [report]="report"
        (pdfDownloaded)="onReportDownloaded()"
        (pdfError)="onReportPdfError()"
      >
      </ptl-playlist-report>
    </div>
  }
</div>
